<template>
  <div>
    <vue-table :table-data="tableData" ref="tableRef">
      <template slot="searchBar">
        <el-form-item label="厂商">
          <company-select v-model="tableData.search.company_id" clearable/>
        </el-form-item>
        <el-form-item label="开始MAC">
          <el-input v-model.trim="tableData.search.start_mac" clearable></el-input>
        </el-form-item>
        <el-form-item label="结束MAC">
          <el-input v-model.trim="tableData.search.end_mac" clearable></el-input>
        </el-form-item>
      </template>
      <template slot="operateBar">
        <el-button v-if="checkApi('addCompanyMac')" size="small" type="primary" @click="add">添加MAC</el-button>
      </template>
      <template slot="mac" slot-scope="{row}">
        {{row.start_mac + " - " + row.end_mac}}
      </template>
      <template slot="percentage" slot-scope="{row}">
        {{(((row.total - row.used) / row.total) * 100).toFixed() + "%" }}
      </template>
      <template slot="total" slot-scope="{row}">
        {{row.total + " / " + row.used}}
      </template>
      <template slot="pool_status" slot-scope="{row}">
        <span v-html="formatData(row.pool_status, poolStatus)"></span>
        <template v-if="row.pool_status=== 3 || row.pool_status === 5">
          <el-tooltip effect="dark" placement="top-start">
            <el-button type="text" icon="el-icon-info" class="info"></el-button>
            <template slot="content">
              <span>{{row.pool_error}}</span>
            </template>
          </el-tooltip>
        </template>
      </template>
      <template v-if="hasApi(['deleteCompanyMac'])" slot="actionBar">
        <el-table-column align="center" label="操作栏" :resizable="false" width="120">
          <template slot-scope="{row}">
            <el-button v-if="checkApi('deleteCompanyMac')" type="text" class="danger" @click="remove(row)" :disabled="!!row.used || row.pool_status === 1 || row.pool_status === 4">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </vue-table>
    <mac-operate v-if="macOperate.visible" :dialog-data="macOperate" @table-reload="getTableList"/>
  </div>
</template>

<script>
  import MacOperate from "./dialog/MacOperate"
  import CompanySelect from "@view/components/select/CompanySelect"
  import {poolStatus} from "@utils/formatList";
  export default {
    name: "macManage",
    components: {MacOperate,CompanySelect},
    data() {
      return {
        poolStatus,
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "ID", property: "id"},
            {label: "厂商", property: "company.name"},
            {label: "MAC段", property: "mac", width: 250},
            {label: "批次", property: "batch_no", width: 150},
            {label: "导入时间", property: "create_at"},
            {label: "剩余(百分比)", property: "percentage", width: 100},
            {label: "MAC总数 / 已使用", property: "total", width: 140},
            {label: "导入状态", property: "pool_status", format: poolStatus, width: 100},
            {label: "创建人", property: "admin.name"},
          ],
          api: "getCompanyMac",
          search: {
            company_id: "",
            start_mac: "",
            end_mac: "",
          },
        },
        macOperate: {visible: false, width: 400, title: "", row: null},
      }
    },
    methods: {
      add() {
        this.macOperate.visible = true;
        this.macOperate.title = "添加厂商MAC";
        this.macOperate.row = null;
      },
      remove(row) {
        this.openConfirm("删除该厂商MAC", async ()=> {
          let nv = {mac_company_id: row.id};
          let res = await this.$Http.deleteCompanyMac(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.getTableList();
          }
        });
      },
      getTableList() {
        this.$refs["tableRef"].refresh();
      },
    },
  }
</script>

<style scoped>

</style>
